{
  "Mon": "lunes",
  "Tue": "martes",
  "Wed": "miércoles",
  "Thu": "jueves",
  "Fri": "viernes",
  "Sat": "sábado",
  "Sun": "domingo",
  "CORE": {
    "notificationDateFormat": "d/M/yy",
    "update": "Loading...",
    "youAreOffline": "Device offline! Connect to a network and try again later!",
    "comeBack": "{{icon}} your skis are waiting for you",
    "help": "ayuda",
    "notification": {
      "ok": "Entendido"
    },
    "skiHire": "Alquiler de esquís"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "start": {
        "selectBookingParametersFact3": "Pague en su propia divisa. Alpy.com se hará cargo del coste del cambio de divisa. Las tasas se actualizan a diario.",
        "searchHeadline": "¿Dónde le gustaría alquilar sus esquís o tablas de snow?"
      },
      "showTownReserveEarlyEnoughInfo": "Tenga en cuenta que pueden faltar equipos en las tiendas durante la temporada. Le recomendamos reservar con antelación."
    },
    "offer": {
      "title": "Por eso con {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "Los mejores precios garantizados para el alquiler de esquís al realizar una reserva en línea",
      "listedBrands": "Marcas disponibles",
      "topTowns": "Los mejores lugares de alquiler de esquís"
    },
    "sidebar": {
      "hotlineItalic": "¡Deje que le ayudemos!",
      "callNow": "Llame ahora al: ",
      "hotline": "Línea directa"
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Especifique la edad de cada niño/a (la edad al inicio del alquiler)",
        "onePersonRequired": "elija una persona al menos",
        "enterTown": "Seleccione una estación de esquí"
      },
      "minified": {
        "users": "{{ number_adults }} adultos, {{ number_children }} niños",
        "date": "{{ start_date }} - {{ end_date }}",
        "dateFormat": "EEEEEE d/M/yy"
      },
      "datePickerDisplayFormat": "EEEEEE d/M/yy",
      "datePickerPreviousMessage": "Puede recoger su equipo en la tienda el <span>{{ date }}</span> después de las 15:30. Excepto esquí nocturno.",
      "datePickerPreviousMessageDateFormat": "d/M/yy",
      "formSearchLabel": "Estación, localidad, país, nombre de la tienda",
      "formSearchInfo": "Un momento, estamos buscando coincidencias…",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "{{ count }} tienda(s)",
      "formSearchResultShowAll": "Mostrar los {{ count }} resultados",
      "formSearchResultGroupLocations": "Localidad",
      "formSearchResultGroupShops": "Shops",
      "formSearchResultGroupRegions": "Región",
      "formSearchResultGroupCountries": "País",
      "formSearchButtonLabelDelivery": "Desde {{price}}",
      "deliverToHotel": "Quiero que el equipo se entregue en mi alojamiento – ¡GRATIS!",
      "formStartDate": "Primer día de alquiler",
      "formEndDate": "Último día de alquiler",
      "formNumberOfPeople": "Número de personas",
      "formAdultsLabel": "Adultos",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "adultos",
        "adultSingle": "adulto",
        "adultMultiple": "adultos",
        "childNone": "niños",
        "childSingle": "niño",
        "childMultiple": "niños"
      },
      "formAdultsLabelInfo": "mayores de 18 años de edad al inicio del alquiler",
      "formChildrenLabel": "Niños",
      "formChildrenLabelInfo": "menores de 18 años de edad al inicio del alquiler",
      "formChildInputLabelInfo": "¿Qué edad tiene su hijo/a? / ¿Qué edad tendrán sus hijos al inicio del alquiler?",
      "formChildInputPlaceholder": "¿qué edad?",
      "formPromotionCode": "Código promocional",
      "formPromotionCodeNotFound": "Este código promocional no existe.",
      "formSearchButtonLabel": "BUSCAR",
      "promocode": {
        "couponCodeIsInCart": "El código del vale {{ code }} se ha añadido a su carro y se incluirá en la página del pago.",
        "typePromo": "Promoción",
        "typeCoupon": "Vale"
      },
      "noResults": "No se han encontrado resultados"
    },
    "navigation": {
      "skihire": "Alquiler de esquís",
      "skischool": "Escuelas de esquí",
      "accommodation": "Alojamientos",
      "aboutUs": "Acerca de nosotros",
      "helpCenter": "Help Center",
      "subnavBooking": "Reserva",
      "subnavAdditionalOffers": "Ofertas adicionales",
      "subnavGroupBooking": "Reservas de grupos",
      "subnavTermsAndConditions": "Términos y condiciones",
      "subnavBecomePartner": "Hacerse socio",
      "subnavPrivacyPolicy": "Política de privacidad",
      "subnavHelp": "Contacto",
      "myAlpinresorts": "Mi Alpy.com",
      "subnavLogin": "Acceso",
      "subnavLogout": "Cerrar sesión",
      "subnavBookingsAndCancellations": "Reservas y cancelaciones",
      "subnavPersonalSettings": "Configuraciones personales",
      "career": "Carrera"
    },
    "geoIp": {
      "chooseACountry": "Elija un país"
    }
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "Acerca de nosotros",
      "metaDescription": "Aquí encontrará toda la información sobre el equipo de {{ productName }}. ¡Confíe en la mayor red de Europa de outlets de alquiler de esquís y escuelas de esquí!"
    },
    "imprint": {
      "title": "Información legal de {{ productName }}",
      "metaDescription": "Aviso legal de {{ productName }}"
    },
    "privacy": {
      "title": "Condiciones de privacidad de {{ productName }}",
      "metaDescription": "Condiciones de privacidad de {{ productName }}"
    },
    "termsAndConditions": {
      "title": "Términos y condiciones generales | {{ productName }}",
      "metaDescription": "Condiciones generales comerciales de {{ productName }}"
    },
    "additionalOffers": {
      "title": "Ofertas adicionales",
      "metaDescription": ""
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "anulowac-rezerwacje",
    "SKIHIREENTRY": "alquiler-de-esquis",
    "COUNTRIES": "paises",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "busqueda"
    },
    "SKISCHOOLENTRY": "escuela-de-esqui",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "aviso-legal",
      "PRIVACYPOLICY": "politica-de-privacidad",
      "TERMSANDCONDITIONS": "terminos",
      "HELP": "ayuda",
      "ABOUTUS": "acerca-de-nosotros",
      "ADDITIONALOFFERS": "ofertas-adicionales",
      "HOWTO": "como-hacerlo"
    }
  }
}